import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import ForgotPasswordService from './forgotpassword.service';
import ForgotPasswordForm from './ForgotPasswordForm.vue';
import IForgotPasswordForm from './forgotpasswordform.interface';
import PageService from '@/core/page.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPassword',
  props: {
    title: null,
    formTitle: null,
    formDescriptionLine1: null,
    formDescriptionLine2: null,
    usernameText: null,
    loginLinkText: null,
    loginLinkUrl: null,
    submitButtonText: null
  },
  emits: ['submit'],
  setup(__props: any) {





const showSpinner = ref(false);
const errorMessage = ref<string>('');

async function submit(form: IForgotPasswordForm) {
    errorMessage.value = '';
    showSpinner.value = true;

    const serverResponse = await ForgotPasswordService.forgotPassword(form)
        .finally(() => showSpinner.value = false);

    if (serverResponse) {
        PageService.hardRedirect(serverResponse.redirectUrl);
    }
};

return { __sfc: true,showSpinner, errorMessage, submit, ForgotPasswordForm }
}

})